// extracted by mini-css-extract-plugin
export default {"footer":"_footer_footer__Qegkl","hairline":"_footer_hairline__Kcxc5","links":"_footer_links__y6lvj","link":"_footer_link__R9Pvu"};